import { FunctionComponent, HTMLAttributes } from 'react';

const EyeOpen: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9992 0.5C9.54378 0.5 11.0998 0.984518 12.5187 1.90039C13.8014 2.72748 14.9463 3.88414 15.8283 5.24609C15.9396 5.41841 15.9986 5.61915 15.9992 5.82422C15.9998 6.02928 15.9416 6.23037 15.8312 6.40332C14.9526 7.7765 13.8319 8.92659 12.55 9.75098C11.137 10.6593 9.56693 11.1396 8.00994 11.1396C6.41824 11.1396 4.8884 10.6742 3.46697 9.75488C2.20431 8.93911 1.04945 7.79064 0.169119 6.41504C0.0548735 6.238 -0.0036239 6.03089 0.000173828 5.82031C0.00399989 5.60978 0.0700692 5.4052 0.190604 5.23242C1.25893 3.70305 2.4892 2.51526 3.84685 1.70215C5.17803 0.90479 6.58204 0.500067 7.9992 0.5ZM7.9992 2.64355C6.24393 2.64373 4.82146 4.06469 4.82146 5.81738C4.82152 7.57003 6.24397 8.99104 7.9992 8.99121C9.75458 8.99121 11.1779 7.57014 11.1779 5.81738C11.1779 4.06458 9.75461 2.64355 7.9992 2.64355ZM7.9992 3.6416C9.20233 3.6416 10.1779 4.61604 10.1779 5.81738C10.1779 7.01867 9.20229 7.99219 7.9992 7.99219C6.79625 7.99201 5.82152 7.01857 5.82146 5.81738C5.82146 4.61615 6.79622 3.64177 7.9992 3.6416Z"
      fill="currentcolor"
    />
  </svg>
);

export default EyeOpen;
